import { DropdownItem } from '@shared/consts';

export enum SaveButtonActions {
  Save = 1,
  SaveAndClose = 2,
  SaveAndAddNew = 3,
}

export enum SaveButtonType {
  OnlySave = 1,
  SaveAndClose = 2,
  SaveAndAddNew = 3,
  AllOptions = 4,
}

/* Currently used only on two levels (on transitions & roles) */
export type SaveButtonCustomAction = DropdownItem & {
  submenu?: SaveButtonCustomAction[];
};

/* Currently used only on two levels (on transitions & roles) */
export type SaveButtonActionEvent = {
  /** Clicked action id */
  id: number;
  /** Clicked submenu action */
  submenu?: SaveButtonActionEvent;
};
